<template>
  <dash-page-new
      :title="$t('TestingProcess')"
      :root="entity.name"
      :mobile-title="entity.name"
      :mobile-side-title="$t('Navigation')"
  >

    <template #header_action>
      <div class="align-center"
           :class="[{'d-flex' : !SM}]"
      >

        <test-navigation
            :class="[{'mt-3' : SM}]"
            v-model="selectedQuestion"
            :questions="entity.questions"
            :all-answered="allAnswered"
            dropdown
        />
        <ws-button
            v-if="allAnswered"
            :to="businessDashLink('courses/test/result/' + entity.student_test_id)"
            label="FinishTest"
            :class="[{'ml-3' : !SM}, {'mt-3' : SM}]"
            :block="SM"
        >
        </ws-button>
      </div>

    </template>

    <template #default>
      <v-divider :class="[{'pb-5' : !SM}]" class="mt-3" :style="`border-color : ${wsBACKGROUND}`" />
      <!-- TESTING PROCESS    -->
      <div class="overflow-auto mx-auto pt-6" style="max-width: 780px" >

        <ws-timer
            v-if="startTimer"
            #default="{time}"
            @finish="testTimeOut"
            :seconds="timeLeft"
        >
          <v-sheet  :style="`border : 1px solid ${wsBACKGROUND}`" class="wsRoundedLight py-2 mb-6">
            <h4 class="wsDARKER text-center d-flex justify-center align-center">
              <v-icon class="mr-2" :color="wsACCENT">mdi-clock-outline</v-icon>
              {{$t('TimeRemained')}}: {{ time }}
            </h4>
          </v-sheet>

        </ws-timer>

        <question-viewer
            :question="entity.questions[selectedQuestion] || {}"
            :order-number="selectedQuestion + 1"
            :course-id="entity.course_id"
            :test-id="entity.uuid"
            @answer="answerQuestion(entity.questions[selectedQuestion], $event)"
        />

        <test-navigation
            class="mt-6 "
            style="margin-bottom: 100px"
            v-model="selectedQuestion"
            :questions="entity.questions"
            :all-answered="allAnswered"
            @finish="$router.push(businessDashLink('courses/test/result/' + entity.student_test_id))"
        />


      </div>
    </template>

  </dash-page-new>
</template>

<script>
import {mapActions} from "vuex";
import testNavigation from "@/components/pages/westudy/tests/UI/testNavigation";
import questionViewer from "@/components/pages/westudy/tests/UI/questionViewer";

export default {
  name: "DashTestPreview",
  props : ['uuid'],
  components : {
    testNavigation,
    questionViewer
  },
  data() {
    return {
      loading : false,
      entity : {
        name : '',
        questions : [],
        duration : 0,
      },
      testResult : {},
      testCompleted : false,
      selectedQuestion : 0,
      displayNavigation : false,
      timeLeft : 0,
      startTimer : false,
    }
  },
  computed : {
    allAnswered() {
      let result = true
      this.entity.questions.forEach((question) => {
        if (!this.hasReply(question)) { result = false }
      })
      return result
    }
  },
  methods : {
    ...mapActions('courses', [
        'GET_TEST_STUDENT',
        'REPLY_ANSWER',
    ]),

    testTimeOut() {
      this.notify(this.$t('TestTimeFinished') , 'warning')
      this.$router.push(this.businessDashLink('courses/test/result/' + this.entity.student_test_id))
    },
    handleTestDuration() {
      if (!this.entity.duration) {
        return
      }

      let timeFromStart = Math.floor((new Date()).getTime()/1000) - this.entity.time_started

      let duration = parseInt(this.entity.duration) * 60

      if ( timeFromStart > duration ) {
        this.testTimeOut()
        return
      }

      duration -= timeFromStart


      this.timeLeft = duration
      this.startTimer = true

    },
    answerQuestion(question,answer ) {
      this.loading = true
      let data = {
        uuid : question.question_id
      }
      if (question.type === 'default') {
       data.answer_id = answer.uuid
      }
      if (question.type === 'true_false') {
        data.answer_bool = answer
      }

      let buffer = this.COPY(answer)

      if ( question.type === 'default' && !question.multiple_type ) {
        question.answers.forEach((answer)=> { answer.reply = false })
        answer.reply = true
      } else if ( question.type === 'default' && question.multiple_type ) {
        answer.reply =  !answer.reply
      } else if ( question.type === 'true_false') {
        question.question_reply_bool = answer
      }


      this.REPLY_ANSWER(data).then((out)=>{
        if ( !out.result ) {
          answer = buffer
          this.ERROR()
        }
        this.loading = false
      })

    },

    refreshTest() {
      this.initPage()
    },

    //technical
    getNavigationColor(question,i) {
      if ( this.selectedQuestion === i ) { return this.wsDARKER }
      return this.hasReply(question) ? this.wsATTENTION : ''
    },


    hasReply(question) {

      if (question.type === 'default' ) {
        let hasAnswer = question.answers.find( el=> el.reply === true )
        return  !!hasAnswer
      }
      if (question.type === 'true_false' ) {
        return  question.question_reply_bool !== null
      }

      return false
    },


    initPage() {
      if ( this.uuid ) {
        this.loading = true;
        this.GET_TEST_STUDENT(this.uuid).then((out)=>{
          if ( out.data ) {
            this.entity = out.data
            this.handleTestDuration()
          } else {
            this.notify(this.$t('NetworkError'))
          }
          this.loading = false
        }).catch(()=>{
          this.notify(this.$t('NetworkError'))
          this.loading = false })
      }
    }
  },

  mounted() {
    this.initPage()
  }
}
</script>

<style scoped>

</style>